import React from 'react';

import Link from 'next/link';
import Image from 'next/image';

import { BoldText } from '@shared/emailCheck/styled';

import { Container, LinkText, Text } from './styled';

type EmailActivationProps = {
  fullName: string | null;
  path: string;
  my?: number;
};

const EmailActivation = ({ fullName, path, my }: EmailActivationProps) => {
  return (
    <Container my={my}>
      <Text isBold paddingBottom={25} fontSize={22}>
        E-posta Aktivasyon
      </Text>
      <Image
        src='/static/images/correct.webp'
        height={60}
        width={60}
        quality={100}
        alt='E-posta Aktifleştirildi'
      />
      {fullName && (
        <Text paddingTop={25} fontSize={16}>
          Sayın <BoldText>{fullName}</BoldText>
        </Text>
      )}
      <Text paddingTop={20}>Üyelik işleminiz başarıyla oluşturulmuştur.</Text>

      <Text fontSize={13} paddingTop={5}>
        Giriş yapmak için lütfen
        <Link href={path} passHref legacyBehavior>
          <LinkText>tıklayın</LinkText>
        </Link>
      </Text>
    </Container>
  );
};
export default EmailActivation;
